export default (text = '', speed = 16) => ({
    full: text ?? '',
    shown: '',
    started: false,
    done: false,
    timer: null,

    start() {
        if (this.started) {
            return;
        }

        this.started = true;

        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.shown = this.full;
            this.done = true;

            return;
        }

        let index = 0;

        const tick = () => {
            index++;
            this.shown = this.full.slice(0, index);

            if (index >= this.full.length) {
                this.done = true;
                this.timer = null;

                return;
            }

            this.timer = setTimeout(tick, speed);
        };

        tick();
    },

    destroy() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    },
});
